// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Formulaire de notification (styles communs dans ../notifications.css) */

.notifications_page .notifications_field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 560px;
}

.notifications_page .notifications_field_label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.notifications_page .notifications_field input,
.notifications_page .notifications_field select,
.notifications_page .notifications_field textarea {
  width: 100%;
  min-height: 40px;
  background-color: var(--bg);
}

.notifications_page .notifications_field select {
  cursor: pointer;
}

.notifications_page .notifications_field textarea {
  resize: vertical;
  line-height: 1.5;
}

.notifications_page .notifications_field .search_user_container,
.notifications_page .notifications_field .search_ticker_container,
.notifications_page .notifications_field .search_sp_container,
.notifications_page .notifications_field .search_signal_provider_container {
  width: 100%;
}

.notifications_page .notifications_field_separated {
  max-width: none;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.notifications_page .notifications_field_separated select {
  max-width: 560px;
}

.notifications_page .notifications_actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 24px;
}

.notifications_page .notifications_actions .notifications_helper {
  flex: 1 1 100%;
  text-align: right;
}

@media (max-width: 768px) {
  .notifications_page .notifications_actions button {
    flex: 1 1;
  }

  .notifications_page .notifications_actions .notifications_helper {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/notifications/builder/notificationBuilder.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Formulaire de notification (styles communs dans ../notifications.css) */\n\n.notifications_page .notifications_field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 560px;\n}\n\n.notifications_page .notifications_field_label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_field input,\n.notifications_page .notifications_field select,\n.notifications_page .notifications_field textarea {\n  width: 100%;\n  min-height: 40px;\n  background-color: var(--bg);\n}\n\n.notifications_page .notifications_field select {\n  cursor: pointer;\n}\n\n.notifications_page .notifications_field textarea {\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.notifications_page .notifications_field .search_user_container,\n.notifications_page .notifications_field .search_ticker_container,\n.notifications_page .notifications_field .search_sp_container,\n.notifications_page .notifications_field .search_signal_provider_container {\n  width: 100%;\n}\n\n.notifications_page .notifications_field_separated {\n  max-width: none;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n.notifications_page .notifications_field_separated select {\n  max-width: 560px;\n}\n\n.notifications_page .notifications_actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.notifications_page .notifications_actions .notifications_helper {\n  flex: 1 1 100%;\n  text-align: right;\n}\n\n@media (max-width: 768px) {\n  .notifications_page .notifications_actions button {\n    flex: 1;\n  }\n\n  .notifications_page .notifications_actions .notifications_helper {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
